import React, { useMemo } from "react";
import ClientProfileEditorScreen from "../../screens/client/ClientProfileEditor";
import VStack from "../../ui_atoms/VStack";
import { MockedProvider } from "@apollo/client/testing";
import { MockedAuthManager } from "../../contexts/AuthManager";
import { buildClientProfile, buildUser } from "../factories";
import type { Meta, StoryObj } from "@storybook/react";
import { ProfileType } from "../../__generated__/graphql";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";

function StoryComponent() {
    const user = useMemo(
        () =>
            buildUser({
                clientProfiles: [buildClientProfile()],
            }),
        [],
    );
    return (
        <MockedAuthManager user={user}>
            <MockedProfileSwitcherManager profileType={ProfileType.Client}>
                <MockedProvider mocks={[]}>
                    <VStack gap={1} style={{ flex: 1 }}>
                        {/* @ts-expect-error Stack Component need a complex navigation handler */}
                        <ClientProfileEditorScreen />
                    </VStack>
                </MockedProvider>
            </MockedProfileSwitcherManager>
        </MockedAuthManager>
    );
}

const meta = {
    title: "Screens/Client profile",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
